export class PqrUserTypeClientEntity{

    id:number;
    userId:number;
    typeClientId:number;
    
    constructor (){}
}